import * as a from "react";
const t = (e) => /* @__PURE__ */ a.createElement(
  "svg",
  {
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...e
  },
  /* @__PURE__ */ a.createElement(
    "path",
    {
      d: "M17 0a1 1 0 110 2h-1c0 1.8-.68 3.58-2.05 4.95L12 8.9v2.2l1.95 1.95A6.98 6.98 0 0116 18h1a1 1 0 110 2H1a1 1 0 110-2h1c0-1.8.68-3.58 2.05-4.95L6 11.1V8.9L4.05 6.95A6.98 6.98 0 012 2H1a1 1 0 010-2h16zM9 4a4.47 4.47 0 00-4 0c-.16.08-.32.15-.49.21a5 5 0 00.95 1.33L8 8.07v4.27a4 4 0 01-1.17 2.83L4 18h10l-2.83-2.83A4 4 0 0110 12.34V8.07l2.54-2.53a5 5 0 001.16-1.82c-.24.08-.47.17-.7.28a4.47 4.47 0 01-4 0z",
      fill: "#2d6ded"
    }
  )
), l = t;
export {
  l as default
};
